module.exports = __webpack_public_path__ + "static/stone-style-2-fd3eccdf106f7b9d978daa537da5b533.png";